const SELECTION_PREFIX = 'selection_';

// Fetch and store the current saved selections from local storage
export async function fetchSavedSelections(setSavedSelections) {
  const savedSelections = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(SELECTION_PREFIX)) {
      try {
        const item = localStorage.getItem(key);
        if (item) {
          const parsedItem = JSON.parse(item);
          savedSelections.push(parsedItem);
        }
      } catch (error) {
        console.error(`Error parsing item with key ${key}:`, error);
      }
    }
  }
  setSavedSelections(savedSelections);
}

// Delete the specified selection from local storage and update the state
export async function fetchDeleteSelections(saveNameToDelete, setSavedSelections) {
  const storageKeyToDelete = `${SELECTION_PREFIX}${saveNameToDelete}`;
  try {
    localStorage.removeItem(storageKeyToDelete);
    // After deleting, refresh the displayed selections
    fetchSavedSelections(setSavedSelections);
    return true; // Indicate successful deletion
  } catch (error) {
    console.error(`Error deleting item with key ${storageKeyToDelete}:`, error);
    return false; // Indicate deletion failure
  }
}